import {
  StandardEditResponseModel,
  StandardResponseModel,
} from "../pages/shared/models/standard-response-model";
import { RegionModel } from "../pages/shared/models/regionModel";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getRegions(
  filter: any,
  limit?: number,
  page?: number,
): Promise<StandardResponseModel<RegionModel>> {
  try {
    const authorizationHeader = configAuthorizationHeader();
    const params = new URLSearchParams();

    if (limit) {
      params.append("limit", "" + limit);
    }
    params.append("page", "" + (page || 0));

    return axiosInstance
      .post(
        `${API_URL}/regions`,
        { filter },
        { params, ...authorizationHeader },
      )
      .then((response) => {
        return response?.data as StandardResponseModel<RegionModel>;
      });
  } catch (error) {
    return Promise.reject(error);
  }
}

async function getRegionById(regionId: number, page?: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(
      `${API_URL}/regions/${regionId}?${page ? "page=" + page : ""}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function createRegion(
  data: RegionModel,
): Promise<StandardResponseModel<RegionModel>> {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .post(
        `${API_URL}/regions/create`,
        {
          ...data,
          city: data.city ? data.city.cityId : undefined,
        },
        authorizationHeader,
      )
      .then((response) => {
        return response?.data as StandardResponseModel<RegionModel>;
      });
  } catch (error) {
    return Promise.reject(error);
  }
}

async function editRegion(regionId: number, updateData: RegionModel) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .put(
        `${API_URL}/regions/${regionId}`,
        {
          ...updateData,
          city: updateData.city ? updateData.city.cityId : undefined,
          regionId: undefined,
        },
        authorizationHeader,
      )
      .then((response) => response?.data as StandardEditResponseModel);
  } catch (error) {
    console.error(error);

    return {
      acknowledged: false,
      matchedCount: 0,
      modifiedCount: 0,
      upsertedCount: 0,
      upsertedId: 0,
    };
  }
}

async function deleteRegionById(regionId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.delete(
      `${API_URL}/regions/${regionId}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  getRegions,
  getRegionById,
  createRegion,
  editRegion,
  deleteRegionById,
};
